import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from '@cbridge-tools/button';
import { IDetailsSidebarViewControlsProps } from './DetailsSidebarViewControls.interface';

export const DetailsSidebarViewControls: FunctionComponent<IDetailsSidebarViewControlsProps> = (props) => {
  const { onEdit } = props;

  const { t } = useTranslation();
  return (
    <SecondaryButton label={t('text:common.button.edit')} onClick={onEdit} />
  );
};
